import servise from '@/router/axios'

// 分页查询转化任务列表
export const getConversionTaskPage = (params) => {
  return servise({
    url: '/ocpx/conversionTask/page',
    method: 'get',
    params
  })
}

// 根据ID查询转化任务详情
export const getConversionTaskById = (id) => {
  return servise({
    url: `/ocpx/conversionTask/${id}`,
    method: 'get'
  })
}

// 根据广告主ID查询转化任务列表
export const getConversionTaskListByAdvertiserId = (advertiserId) => {
  return servise({
    url: `/ocpx/conversionTask/advertiser/${advertiserId}`,
    method: 'get'
  })
}

// 根据渠道 ID查询转化任务列表
export const getConversionTaskListByChannelId = (channelId) => {
  return servise({
    url: `/ocpx/conversionTask/channel/${channelId}`,
    method: 'get'
  })
}

// 根据投放计划ID查询转化任务列表
export const getConversionTaskListByCampaignId = (campaignId) => {
  return servise({
    url: `/ocpx/conversionTask/campaign/${campaignId}`,
    method: 'get'
  })
}

// 新增转化任务
export const addConversionTask = (data) => {
  return servise({
    url: '/ocpx/conversionTask',
    method: 'post',
    data
  })
}

// 更新转化任务
export const updateConversionTask = (data) => {
  return servise({
    url: '/ocpx/conversionTask',
    method: 'put',
    data
  })
}

// 删除转化任务
export const deleteConversionTask = (id) => {
  return servise({
    url: `/ocpx/conversionTask/${id}`,
    method: 'delete'
  })
}

// 更新转化任务状态
export const updateConversionTaskStatus = (id, status) => {
  return servise({
    url: `/ocpx/conversionTask/${id}/status/${status}`,
    method: 'put'
  })
}

// 绑定渠道和投放计划，生成监测 URL
export const bindChannelAndCampaign = (taskId, channelId, campaignId) => {
  return servise({
    url: `/ocpx/conversionTask/${taskId}/bind`,
    method: 'put',
    params: { channelId, campaignId }
  })
}

// 查询所有启用的 RTA 服务
export const getEnabledRtaList = () => {
  return servise({
    url: '/ocpx/rta/enabled/list',
    method: 'get'
  })
}
